import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/RequestEngagementGoogleDocsReport.graphql';
import { Mutation, MutationrequestEngagementGoogleDocsReportArgs } from '../../__generated__/globalTypes';

export const useRequestEngagementGoogleDocsReportMutation = (
  options?: MutationHookOptions<Mutation, MutationrequestEngagementGoogleDocsReportArgs>
) => {
  const [callRequestEngagementGoogleDocsReport, result] = useMutation<
    Mutation,
    MutationrequestEngagementGoogleDocsReportArgs
  >(MUTATION, options);

  return { callRequestEngagementGoogleDocsReport, ...result };
};

export type RequestEngagementGoogleDocsReportMutationFunction = Mutation['requestEngagementGoogleDocsReport'];
